export default __webpack_public_path__ + "static/media/34.a1d1ae89.jpg";